/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Button,
  CardMedia,
  Checkbox,
  Dialog,
  Grid,
  IconButton,
  InputAdornment,
  Tooltip,
  Typography,
} from '@mui/material';
import { Box } from '@mui/system';
import { Formik, validateYupSchema, yupToFormErrors } from 'formik';
import React, { useEffect, useState } from 'react';
import {
  AuthorisedSignatories as POAAuthorisedSignatories,
  Groups,
  GroupSignatories,
  individuals_Poa_nonIndividuals_Documents,
  Document,
  ApplicationProps,
} from '../../redux-store/types/api-types';
import {
  PEPsMasters,
  genderMasters,
  getGroupNameMaster,
  relatedPersonTypeMaster,
  salutationsMasters,
} from '../../utils/constant';
import { DataTable } from '../DataTable';
import AddIcon from '@mui/icons-material/Add';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { ProceedSaveLater } from '../investors/components';
import { MFTextField } from '../../lib/formik';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { getDocuments, updateApplication } from '../../redux-store/actions/application';
import { useHistory } from 'react-router';
import {
  applicationComparison,
  checkIfApplicationIsNonIndividualPOA,
  checkValidationBasedOnDate,
  checkforOtherRelatedPerson,
  documentNameValidationCheckForDocumentExpiryDate,
  documentTypeValidationCheckForDocumentNumberDocumentExpiryDate,
  getArrayLength,
  getLabelForDocumentNumber,
  isRelatedPersonTypeDirector,
  preventSpecialCharacters,
  removeSingleQuote,
  saveForLater,
} from '../../utils/utilityFunctions';
import { nonIndividualAuthorisedSignatories } from '../../utils/schema';
import { ConfirmationDialog, CountryCodesDropDown } from '../commonComponents';
import { showError } from '../../redux-store/actions/auth';
import { useSnackbar } from 'notistack';
import { FileUpload } from './DocumentDetails';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { documentDetails } from '../investors/documentDetails';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import { mdmsCountriesList, nationaliyType } from '../../redux-store/types/mdms';
import { getNationalityList } from '../../redux-store/actions';
import MFSelectField from '../../lib/formik/SelectField';
import { DatePicker } from '../../lib/formik/DatePicker';
import { TextDatePicker } from '../../lib/formik/DatePickerWithTextFeild';
// type GroupsProps = {
//   name: string;
//   threshold: number;
//   groupsignatories: GroupSignatories[];
// };

// export type Values = {
//   groups: GroupsProps[];
//   saveType: string;
// };

export const GroupSignatoriesObject: GroupSignatories = {
  groupId: '',
  name: '',
  namePrefix: 'Mr.',
  pan: '',
  mobile: '',
  countryNameAndCode: 'India: +91',
  countryCode: '+91',
  email: '',
  designation: '',
  canEsign: true,
  isActive: true,
  groupsignatorydocuments: [],
  aadhaar: '',
  din_uid: '',
  ckycNo: '',
  fatherName: '',
  fatherOrSpouseNamePrefix: 'Mr.',
  motherNamePrefix: 'Mrs.',
  motherName: '',
  uid: '',
  dateOfBirth: '',
  gender: '',
  nationality: '',
  address1: '',
  address2: '',
  address3: '',
  city: '',
  state: '',
  country: '',
  pincode: '',
  pepStatus: 'Not Applicable',
  relatedPersonType: '',
  otherRelatedPersonType: '',
};

// const initialValues: Values = {
//   groups: [
//     {
//       name: '',
//       threshold: 1,
//       groupsignatories: [GroupSignatoriesObject],
//     },
//   ],
//   saveType: 'save and proceed',
// };

const headers = [
  {
    header: 'Name',
    label: 'name',
    valueGetter: (row: GroupSignatories) =>
      (row.name && row.namePrefix ? row.namePrefix + ' ' : '') + (row.name ? row.name : '') ||
      'N/A',
  },
  {
    header: 'PAN',
    valueGetter: (row: GroupSignatories) => row.pan.toUpperCase() || 'N/A',
  },
  {
    header: 'Email ID',
    valueGetter: (row: GroupSignatories) => row.email || 'N/A',
  },
  {
    header: 'Designation',
    valueGetter: (row: GroupSignatories) => row.designation || 'N/A',
  },
];

export const poaAuthorisedheaders = [
  {
    header: `Name`,
    valueGetter: (row: POAAuthorisedSignatories) => row.user.firstName || 'N/A',
  },
  {
    header: 'Mobile Number',
    valueGetter: (row: POAAuthorisedSignatories) => row.user.phone || 'N/A',
  },
  {
    header: 'Email Id',
    valueGetter: (row: POAAuthorisedSignatories) => row.user.email || 'N/A',
  },
];

export const viewDownloadCell = (docData: documentDetails[]): any => {
  return docData.map((_doc_data) => {
    return {
      header: _doc_data.documentName,
      renderEditDeleteCell: (row: GroupSignatories): JSX.Element => {
        return (
          <>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: { xs: 'flex-start', md: 'center' },
              }}>
              {row.groupsignatorydocuments.map((rowData) => {
                const fileData: any = rowData?.file || rowData?.fileView;
                {
                  return fileData?.id ? (
                    <>
                      {fileData?.viewUrl && (
                        <Tooltip title="View">
                          <IconButton onClick={() => window.open(fileData?.viewUrl, '_blank')}>
                            <RemoveRedEyeIcon />
                          </IconButton>
                        </Tooltip>
                      )}

                      {fileData?.url && (
                        <Tooltip title="Download">
                          <IconButton
                            sx={{
                              p: 0,
                              pr: 0.5,
                              ':hover': {
                                bgcolor: '#F4FCFC',
                              },
                              cursor: 'pointer',
                              pointerEvents: 'all',
                              mb: 1,
                            }}
                            onClick={() => window.open(fileData?.url, '_blank')}>
                            <CardMedia
                              component="img"
                              src={'/images/download-icon.png'}
                              alt="Download"
                              sx={{ width: '25px' }}
                            />
                          </IconButton>
                        </Tooltip>
                      )}
                    </>
                  ) : (
                    <div>N/A</div>
                  );
                }
              })}
            </Box>
          </>
        );
      },
    };
  });
};

export const getASDocuments = (
  response: Document | null,
  signatory: GroupSignatories
): documentDetails[] => {
  return (
    (
      (response?.non_individual_autherized_signatory as unknown as individuals_Poa_nonIndividuals_Documents[]) ||
      []
    ).map((responseData) => {
      if (signatory.groupsignatorydocuments && signatory.groupsignatorydocuments?.length > 0) {
        return signatory.groupsignatorydocuments
          .reduce((acc: documentDetails[], groupData) => {
            if (groupData.documentType === responseData.documentType) {
              const { required, multipleFiles, ...rest } = responseData;
              acc.push({ ...groupData, required, multipleFiles });
            }
            return acc;
          }, [])
          .flat();
      } else {
        return { ...responseData, documentId: '', isActive: true };
      }
    }) as unknown as documentDetails[]
  ).flat();
};

export const ProofDetails = ({
  index,
  doc,
}: {
  index: number;
  doc: documentDetails;
}): JSX.Element => {
  const { application } = useSelector((store: RootStateType) => store.application);
  return (
    <>
      <Grid
        item
        sx={{
          mt: 4,
          paddingLeft: '0px!important',
        }}
        xs={12}
        sm={6}>
        <MFTextField
          name={`groupsignatorydocuments.${index}.documentNumber`}
          label={`${getLabelForDocumentNumber(doc.documentType)} *`}
          placeholder="Enter Identification Number"
        />
      </Grid>
      <Grid
        item
        sx={{
          mt: 4,
          paddingRight: '0px!important',
        }}
        xs={12}
        sm={6}>
        <TextDatePicker
          label={`Expiry Date ${
            documentNameValidationCheckForDocumentExpiryDate(doc.documentName) ? '*' : ''
          }`}
          inputLabelStyles={{
            transform: 'unset',
            fontSize: 14,
            fontWeight: 500,
            color: 'rgba(0,0,0,0.7)',
            display: 'contents',
          }}
          placeholder={'DD/MM/YYYY'}
          maxDate={new Date(new Date().setFullYear(new Date().getFullYear() + 120))}
          minDate={new Date(new Date().setDate(new Date().getDate()))}
          name={`groupsignatorydocuments.${index}.documentExpiryDate`}
        />
      </Grid>
    </>
  );
};

export default function AuthorisedSignatories(): JSX.Element {
  const [authorisedSignatoriesGroup, setAuthorisedSignatoriesGroup] = useState<Groups[]>([]);
  const [authorisedSignatories, setAuthorisedSignatories] = useState(GroupSignatoriesObject);
  const [loading, setLoading] = useState(false);
  const [saveType, setSaveType] = useState('');
  const [open, setOpen] = useState(false);
  const { application } = useSelector((store: RootStateType) => store.application);
  const [groupSignatoriesDocData, setGroupSignatoriesDocData] = useState<documentDetails[]>([]);

  // const [thresholdValue, setThresholdValue] = useState(1);
  const [groupIndex, setGroupIndex] = useState(Number);
  const [rowIndex, setRowIndex] = useState(Number);
  const history = useHistory();
  const dispatch = useDispatch();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const [deletePopup, setDeletePopup] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const [nationalitiesMdmsResponse, setMdmsCountriesList] = useState<mdmsCountriesList[]>([]);

  useEffect(() => {
    (async function () {
      try {
        const { groups = [] } = application || {};
        const nationalitiesMdmsMasters = (await dispatch(
          getNationalityList()
        )) as unknown as nationaliyType;
        setMdmsCountriesList(nationalitiesMdmsMasters.countries);
        const response = (await dispatch(getDocuments())) as unknown as Document;
        const groupSignatoryData = (
          (response?.non_individual_autherized_signatory as unknown as individuals_Poa_nonIndividuals_Documents[]) ||
          []
        ).map((_doc) => {
          return {
            ..._doc,
            documentId: '',
            documentNumber: '',
            documentExpiryDate: null,
            isActive: true,
          };
        });
        setGroupSignatoriesDocData(groupSignatoryData);
        setAuthorisedSignatoriesGroup(
          groups.length
            ? groups.map((group) => {
                return {
                  ...group,
                  groupsignatories: group.groupsignatories.map((signatory) => {
                    return {
                      ...signatory,
                      countryCode: signatory.countryCode ? signatory.countryCode : '+91',
                      countryNameAndCode: signatory.countryNameAndCode
                        ? signatory.countryNameAndCode
                        : 'India: +91',
                      groupsignatorydocuments: getASDocuments(response, signatory),
                      pepStatus: signatory.pepStatus || '',
                      relatedPersonType: signatory.relatedPersonType || '',
                      otherRelatedPersonType: signatory.otherRelatedPersonType || '',
                      fatherOrSpouseNamePrefix: signatory.fatherOrSpouseNamePrefix || 'Mr.',
                      motherNamePrefix: signatory.motherNamePrefix || 'Mrs.',
                      namePrefix: signatory.namePrefix || 'Mr.',
                    };
                  }),
                };
              })
            : [
                {
                  name: '',
                  threshold: 1,
                  groupsignatories: [],
                },
              ]
        );
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, [application]);

  const handleClose = () => {
    setAuthorisedSignatories({
      ...GroupSignatoriesObject,
      groupsignatorydocuments: groupSignatoriesDocData,
    }),
      setRowIndex(Number),
      setGroupIndex(Number),
      setOpen(false);
  };

  const onSubmit = (values: GroupSignatories) => {
    const editsignatory = authorisedSignatoriesGroup[groupIndex].groupsignatories
      .filter((_item) => _item.isActive)
      .map((signatory, _ind) => {
        if (rowIndex === _ind) {
          return { ...values, countryCode: values.countryNameAndCode.split(':')[1].trim() };
        }
        return signatory;
      });
    const deletedsignatory = authorisedSignatoriesGroup[groupIndex].groupsignatories.filter(
      (_item) => !_item.isActive && _item.id
    );

    const addSignatoriesGroup = authorisedSignatoriesGroup.map((group, ind) => {
      if (ind === groupIndex) {
        return {
          ...group,
          name: getGroupNameMaster[groupIndex],
          threshold: group.threshold,
          groupsignatories: [
            authorisedSignatories.pan,
            authorisedSignatories.mobile,
            authorisedSignatories.email,
          ].includes('')
            ? [
                ...group.groupsignatories,
                { ...values, countryCode: values.countryNameAndCode.split(':')[1].trim() },
              ]
            : [...editsignatory, ...deletedsignatory],
        };
      }
      return group;
    });
    setAuthorisedSignatoriesGroup(addSignatoriesGroup);
    handleClose();
  };

  const handleSubmit = async (saveTypeText: string) => {
    try {
      const { id, applicant1ReferenceId = '', currentStep, applicationNumber } = application || {};
      if (!checkIfApplicationIsNonIndividualPOA(application as ApplicationProps)) {
        authorisedSignatoriesGroup.map((group) => {
          const getActiveSignatories = group.groupsignatories.filter((item) => item.isActive);
          const getCanEsignCount = getActiveSignatories.filter((item) => item.canEsign);
          if (!getActiveSignatories.length) {
            throw 'Please add Authorised Signatories';
          }
          if (!getCanEsignCount.length) {
            throw 'Please Select a member for E-Sign';
          }
          if (getCanEsignCount.length < group.threshold) {
            throw 'Authorised Signatories that can esign can not be less than the Total No. of required Authorised Signatories';
          }
          return group;
        });
      }
      const setGroupSignatoryData = (documentsData: documentDetails[]): documentDetails[] => {
        return documentsData.map((documentData) => {
          const { multipleFiles, required, ...rest } = documentData;
          return rest;
        });
      };
      const checkApplication = applicationComparison(
        {
          ...application,
        },
        {
          ...application,
          groups: checkIfApplicationIsNonIndividualPOA(application as ApplicationProps)
            ? application?.groups
            : authorisedSignatoriesGroup.map((group) => ({
                ...group,
                groupsignatories: group.groupsignatories.map((groupsignatory) => ({
                  ...groupsignatory,
                  name: removeSingleQuote(groupsignatory.name),
                  designation: removeSingleQuote(groupsignatory.designation),
                  email: removeSingleQuote(groupsignatory.email),
                  otherRelatedPersonType: checkforOtherRelatedPerson(
                    groupsignatory.relatedPersonType
                  )
                    ? groupsignatory.otherRelatedPersonType
                    : '',
                  groupsignatorydocuments: setGroupSignatoryData(
                    groupsignatory.groupsignatorydocuments
                  ),
                  din_uid: isRelatedPersonTypeDirector(groupsignatory.relatedPersonType)
                    ? groupsignatory.din_uid
                    : '',
                  uid: !isRelatedPersonTypeDirector(groupsignatory.relatedPersonType)
                    ? groupsignatory.uid
                    : '',
                })),
                isActive: true,
              })),
          currentStep: !!currentStep && currentStep > 6 ? currentStep : Number(currentStep) + 1,
        }
      );
      if (id && !checkApplication) {
        setSaveType(saveTypeText);
        setLoading(true);
        await dispatch(
          updateApplication({
            body: {
              ...application,
              groups: checkIfApplicationIsNonIndividualPOA(application as ApplicationProps)
                ? application?.groups
                : authorisedSignatoriesGroup.map((group) => ({
                    ...group,
                    groupsignatories: group.groupsignatories.map((groupsignatory) => ({
                      ...groupsignatory,
                      name: removeSingleQuote(groupsignatory.name),
                      designation: removeSingleQuote(groupsignatory.designation),
                      email: removeSingleQuote(groupsignatory.email),
                      relatedPersonType: groupsignatory.relatedPersonType,
                      otherRelatedPersonType: checkforOtherRelatedPerson(
                        groupsignatory.relatedPersonType
                      )
                        ? groupsignatory.otherRelatedPersonType
                        : '',
                      groupsignatorydocuments: setGroupSignatoryData(
                        groupsignatory.groupsignatorydocuments
                      ),
                      din_uid: isRelatedPersonTypeDirector(groupsignatory.relatedPersonType)
                        ? groupsignatory.din_uid
                        : '',
                      uid: !isRelatedPersonTypeDirector(groupsignatory.relatedPersonType)
                        ? groupsignatory.uid
                        : '',
                    })),
                    isActive: true,
                  })),
              currentStep: 7,
            },
            applicationId: id,
            ...(saveTypeText !== 'save and proceed' && {
              toastMessage: '',
            }),
          })
        );
        saveTypeText === 'save and proceed'
          ? history.push('declaration-ubo', { id, applicant1ReferenceId })
          : history.push(saveForLater(role, id, applicant1ReferenceId));
      } else if (checkApplication) {
        if (saveTypeText !== 'save and proceed') {
          enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
            variant: 'success',
            autoHideDuration: 3000,
          });
        }
        saveTypeText === 'save and proceed'
          ? history.push('declaration-ubo', { id, applicant1ReferenceId })
          : history.push(saveForLater(role, id, applicant1ReferenceId));
      }
    } catch (e) {
      setLoading(false);
      typeof e === 'string' && dispatch(showError(e));
      console.error((e as Error).message);
    }
  };

  const editCell = {
    header: '',
    renderEditDeleteCell: (
      row: GroupSignatories,
      index: number,
      _groupIndex?: number
    ): JSX.Element => {
      return (
        <Box display="flex" alignItems="center" justifyContent="center">
          <Tooltip title="Edit">
            <IconButton
              onClick={() => {
                // let checkindex = 0;
                const groupSignatoryForView = groupSignatoriesDocData.map((doc, index) => {
                  const documentData = row?.groupsignatorydocuments[index];
                  if (documentData) {
                    if (
                      documentData.documentId ===
                      (documentData?.file?.id || documentData?.fileView?.id)
                    ) {
                      return {
                        ...documentData,
                        // documentNumber: '1234',
                        documentNumber: documentData?.documentNumber,
                        file: documentData?.fileView || documentData?.file,
                        documentExpiryDate: documentData?.documentExpiryDate || null,
                        documentName: documentData?.documentName,
                        options: groupSignatoriesDocData.find(
                          (doc) => doc.documentType === documentData.documentType
                        )?.options,
                      };
                    } else {
                      return {
                        ...documentData,
                      };
                    }
                  } else {
                    return { ...doc };
                  }
                });
                setAuthorisedSignatories({
                  ...row,
                  groupsignatorydocuments: groupSignatoryForView,
                });
                typeof _groupIndex !== 'undefined' && setGroupIndex(_groupIndex),
                  setRowIndex(index),
                  setOpen(true);
              }}
              sx={{
                ':hover': {
                  bgcolor: '#F4FCFC',
                },
              }}>
              <EditIcon sx={{ color: 'primary.main' }} fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton
              onClick={() => {
                setAuthorisedSignatories(row),
                  typeof _groupIndex !== 'undefined' && setGroupIndex(_groupIndex),
                  setRowIndex(index),
                  setDeletePopup(true);
              }}
              sx={{
                ':hover': {
                  bgcolor: '#F4FCFC',
                },
              }}>
              <DeleteOutlineIcon color="error" fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      );
    },
  };

  const sendToEsignCell = {
    header: (): JSX.Element => {
      const [open, setOpen] = useState(false);

      const handleOpen = () => {
        setOpen(true);
      };
      const handleClose = () => {
        setOpen(false);
      };
      return (
        <>
          <Typography
            variant="h6"
            sx={{
              fontFamily: 'Poppins, sans-serif',
              fontSize: 14,
              fontWeight: 500,
              color: 'primary.main',
              pr: 0.5,
            }}
            component="span">
            Send e-sign link
          </Typography>
          <InfoOutlinedIcon
            color="info"
            fontSize="small"
            onClick={handleOpen}
            sx={{ position: 'relative', top: 4 }}
          />

          <Dialog
            onClose={handleClose}
            open={open}
            sx={{
              '.MuiPaper-root ': {
                maxWidth: 400,
                p: { xs: 2, sm: '15px 20px 45px' },
                borderRadius: '10px',
                height: 'unset',
                overflowY: 'auto',
              },
            }}>
            <IconButton onClick={handleClose} sx={{ alignSelf: 'flex-end' }}>
              <CloseIcon fontSize="medium" />
            </IconButton>
            <Box sx={{ mb: 2, textAlign: 'center', '.MuiSvgIcon-root': { fontSize: '3.1875rem' } }}>
              <InfoOutlinedIcon color="info" fontSize="large" />
            </Box>
            <Box
              sx={{
                width: { xs: '100%', sm: '80%' },
                mx: 'auto',
                '.MuiTypography-root': {
                  fontSize: 20,
                  fontWeight: 500,
                  textAlign: 'center',
                },
              }}>
              <Typography sx={{ color: 'secondary.main', lineHeight: '35px' }}>
                Use this option to send the e-sign link to specific set of authorized signatories.
              </Typography>
            </Box>
          </Dialog>
        </>
      );
    },
    renderEditDeleteCell: (
      row: GroupSignatories,
      index: number,
      group_Index?: number
    ): JSX.Element => {
      return (
        <Checkbox
          checked={row.canEsign}
          // defaultChecked
          sx={{ display: { xs: 'block' }, ':hover': { backgroundColor: 'white' } }}
          onChange={() => {
            const setCanEsign = authorisedSignatoriesGroup.map((group, ind) => {
              if (ind === group_Index) {
                return {
                  ...group,
                  name: getGroupNameMaster[group_Index],
                  threshold: group.threshold,
                  groupsignatories: [
                    ...group.groupsignatories
                      .filter((_item) => _item.isActive)
                      .map((signatory, _ind) => {
                        if (index === _ind) {
                          return { ...signatory, canEsign: !signatory.canEsign };
                        }
                        return signatory;
                      }),
                    ...authorisedSignatoriesGroup[groupIndex].groupsignatories.filter(
                      (_item) => !_item.isActive && _item.id
                    ),
                  ],
                };
              }
              return group;
            });

            setAuthorisedSignatoriesGroup(setCanEsign);
          }}
        />
      );
    },
  };

  const [mobileElementWidth, setMobileElementWidth] = useState(null);
  useEffect(() => {
    const mobileElement = document.getElementsByName('mobile');
    setMobileElementWidth(mobileElement[0]?.parentElement?.clientWidth as any);
  }, []);
  return (
    <Grid
      container
      rowSpacing={1}
      //columnSpacing={5}
      sx={{
        width: '100%',
        ml: 0,
        '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
      }}>
      {checkIfApplicationIsNonIndividualPOA(application as ApplicationProps) ? (
        <>
          <Typography sx={{ color: 'primary.main', fontSize: '16px' }} mb={4} mt={1}>
            Total No. of required authorised signatories for E-sign :{' '}
            <Typography
              component="span"
              sx={{ backgroundColor: 'rgba(97, 209, 214, 0.07)', px: 3, py: 0.5 }}>
              {application?.requiredAuthorisedSignatory}
            </Typography>
          </Typography>
          {application?.poaauthorisedsignatories &&
            application?.poaauthorisedsignatories.length !== 0 && (
              <Grid xs={12} sm={12} lg={12}>
                <DataTable
                  tableData={application?.poaauthorisedsignatories}
                  tableHeader={poaAuthorisedheaders}
                  renderAdditionalRow={false}
                  tableHeaderCustomStyles={{
                    '.MuiTableCell-head': {
                      fontFamily: 'Poppins, sans-serif',
                      fontSize: 14,
                      fontWeight: 500,
                      color: 'primary.main',
                    },
                  }}
                  rowCustomStyles={{
                    '.MuiTableCell-root': {
                      py: '8px',
                      overflowWrap: 'anywhere',
                    },
                  }}
                  boxStyles={{ minHeight: '0px', minWidth: 450 }}
                />
              </Grid>
            )}
        </>
      ) : (
        <>
          {authorisedSignatoriesGroup.map((group, index) => (
            <React.Fragment key={index}>
              <Grid
                sx={{
                  display: 'flex',
                }}
                alignItems="center"
                mb={4}
                mt={1}>
                <Typography sx={{ color: 'primary.main', fontSize: '16px' }}>
                  Total No. of required authorised signatories
                  <Typography component="span" sx={{ color: '#BD2932' }}>
                    *
                  </Typography>{' '}
                  :
                </Typography>
                <Box
                  sx={{
                    width: '100px',
                    ml: 2,
                    '.MuiOutlinedInput-root': {
                      marginTop: '0',
                      backgroundColor: 'rgba(97, 209, 214, 0.07)',
                      '&.MuiInputBase-root': {
                        '& .MuiSelect-select': {
                          padding: '7px 38px',
                          border: 'none',
                        },
                      },
                      '.MuiOutlinedInput-notchedOutline': {
                        border: 'none',
                      },
                    },

                    '&.Mui-focused,&:hover': {
                      '.MuiOutlinedInput-notchedOutline': {
                        borderWidth: 'none',
                      },
                    },
                    svg: {
                      color: '#337FC9',
                    },
                  }}>
                  <Select
                    labelId="user-items"
                    onChange={(e) => {
                      const updatethreshold = authorisedSignatoriesGroup.map((_group, _ind) => {
                        if (index === _ind) {
                          return {
                            ..._group,
                            threshold: Number(e.target.value),
                          };
                        }
                        return _group;
                      });
                      setAuthorisedSignatoriesGroup(updatethreshold);
                    }}
                    value={group.threshold}
                    sx={{
                      color: 'primary.main',
                      fontWeight: 500,
                    }}
                    MenuProps={{
                      sx: {
                        '.MuiPaper-root ': {
                          maxHeight: '20%',
                        },
                      },
                    }}>
                    {getArrayLength(
                      group.groupsignatories.filter((_signatory) => _signatory.isActive).length || 1
                    ).map((thresholdValue, ind) => (
                      <MenuItem
                        sx={{
                          borderBottom: '1px solid #ccc',
                          textAlign: 'center',
                          '&:last-child': { border: 'none' },
                          justifyContent: 'center',
                        }}
                        value={thresholdValue}
                        key={ind}>
                        {thresholdValue}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              </Grid>
              {group.groupsignatories.filter((_signatory) => _signatory.isActive).length !== 0 && (
                <Grid xs={12} sm={12} lg={12}>
                  <DataTable
                    groupIndex={index}
                    tableData={group.groupsignatories.filter((_signatory) => _signatory.isActive)}
                    tableHeader={[
                      sendToEsignCell,
                      ...headers,
                      // ...viewDownloadCell(groupSignatoriesDocData),
                      editCell,
                    ]}
                    renderAdditionalRow={false}
                    tableHeaderCustomStyles={{
                      '.MuiTableCell-head': {
                        fontFamily: 'Poppins, sans-serif',
                        fontSize: 14,
                        fontWeight: 500,
                        color: 'primary.main',
                      },
                    }}
                    rowCustomStyles={{
                      '.MuiTableCell-root': {
                        py: '8px',
                        overflowWrap: 'anywhere',
                      },
                    }}
                    boxStyles={{ minHeight: '0px', minWidth: 450 }}
                  />
                </Grid>
              )}
              {group.groupsignatories.filter((item) => item.isActive).length < 3 && (
                <Grid
                  xs={12}
                  sm={12}
                  lg={12}
                  display="flex"
                  sx={{
                    justifyContent: {
                      xs:
                        group.groupsignatories.filter((_signatory) => _signatory.isActive)
                          .length === 0
                          ? 'start'
                          : 'center',
                      sm:
                        group.groupsignatories.filter((_signatory) => _signatory.isActive)
                          .length === 0
                          ? 'start'
                          : 'end',
                    },
                  }}>
                  <Button
                    variant="outlined"
                    startIcon={<AddIcon />}
                    sx={{
                      color: 'primary.main',
                      fontWeight: 500,
                      fontSize: 13,
                      mr: 2.5,
                      whiteSpace: 'nowrap',
                      mt: '20px',
                    }}
                    onClick={() => {
                      setAuthorisedSignatories({
                        ...GroupSignatoriesObject,
                        groupsignatorydocuments: groupSignatoriesDocData,
                      }),
                        setGroupIndex(index),
                        setOpen(true);
                    }}>
                    Add Authorised Signatory
                  </Button>
                </Grid>
              )}
            </React.Fragment>
          ))}
        </>
      )}
      <ProceedSaveLater
        saveLater={() => {
          handleSubmit('save for later');
        }}
        saveAndProceed={() => {
          handleSubmit('save and proceed');
        }}
        loader={loading}
        clickedButton={saveType}
      />

      <Dialog
        onClose={handleClose}
        open={open}
        sx={{
          '.MuiPaper-root ': {
            p: 4,
            // width: { xs: '70%', sm: '70%' },
            pt: 2,
            maxWidth: 900,
          },
        }}>
        <IconButton onClick={handleClose} sx={{ alignSelf: 'flex-end' }}>
          <CloseIcon fontSize="small" />
        </IconButton>
        <Box
          sx={{
            width: { xs: '100%', sm: '100%' },
            mx: 'auto',
            '.MuiTypography-root': {
              textAlign: 'center',
            },
            '.MuiFormControl-root': { my: 1 },
            px: { xs: '0', sm: 5 },
          }}>
          <Typography
            sx={{
              color: '#0D2762',
              position: 'relative',
              bottom: '20px',
              fontSize: '23px',
              fontWeight: 500,
            }}>
            {authorisedSignatories.pan ? 'Edit Member' : 'Add Member'}
          </Typography>

          <Formik
            initialValues={authorisedSignatories}
            onSubmit={onSubmit}
            validate={(values: GroupSignatories) => {
              const setValuesForEdit = authorisedSignatoriesGroup.map((group, _ind) => {
                if (_ind === groupIndex) {
                  return {
                    ...group,
                    groupsignatories: group.groupsignatories
                      .filter((_signatory) => _signatory.isActive)
                      .map((_signatory, index) => {
                        if (index === rowIndex) {
                          if (
                            values.pan !== _signatory.pan &&
                            values.mobile !== _signatory.mobile &&
                            values.email !== _signatory.email
                          ) {
                            return _signatory;
                          }
                          if (
                            values.pan === _signatory.pan &&
                            values.mobile === _signatory.mobile &&
                            values.email === _signatory.email
                          ) {
                            const { mobile, email, pan, ...rest } = _signatory;
                            return { ...rest };
                          }
                          if (
                            values.pan !== _signatory.pan &&
                            values.mobile === _signatory.mobile &&
                            values.email === _signatory.email
                          ) {
                            const { mobile, email, ...rest } = _signatory;
                            return { ...rest };
                          }
                          if (
                            values.pan === _signatory.pan &&
                            values.mobile !== _signatory.mobile &&
                            values.email === _signatory.email
                          ) {
                            const { pan, email, ...rest } = _signatory;
                            return { ...rest };
                          }
                          if (
                            values.pan === _signatory.pan &&
                            values.mobile === _signatory.mobile &&
                            values.email !== _signatory.email
                          ) {
                            const { mobile, pan, ...rest } = _signatory;
                            return { ...rest };
                          }
                          if (
                            values.pan !== _signatory.pan &&
                            values.mobile !== _signatory.mobile &&
                            values.email === _signatory.email
                          ) {
                            const { email, ...rest } = _signatory;
                            return { ...rest };
                          }
                          if (
                            values.pan !== _signatory.pan &&
                            values.mobile === _signatory.mobile &&
                            values.email !== _signatory.email
                          ) {
                            const { mobile, ...rest } = _signatory;
                            return { ...rest };
                          }
                          if (
                            values.pan === _signatory.pan &&
                            values.mobile !== _signatory.mobile &&
                            values.email !== _signatory.email
                          ) {
                            const { pan, ...rest } = _signatory;
                            return { ...rest };
                          }
                          return;
                        }
                        return _signatory;
                      }),
                  };
                }
                return group;
              });
              try {
                validateYupSchema(
                  values,
                  nonIndividualAuthorisedSignatories(
                    nationalitiesMdmsResponse,
                    application?.createdAt || ''
                  ),
                  true,
                  authorisedSignatories.pan
                    ? setValuesForEdit
                    : authorisedSignatoriesGroup.map((_group) => {
                        return {
                          ..._group,
                          groupsignatories: _group.groupsignatories.filter(
                            (_signatory) => _signatory.isActive
                          ),
                        };
                      })
                );
              } catch (e) {
                return yupToFormErrors(e);
              }
            }}
            enableReinitialize={true}>
            {({ handleSubmit, setFieldValue, values }) => (
              <Grid
                container
                rowSpacing={1}
                //columnSpacing={5}
                sx={{
                  width: '100%',
                  ml: 0,
                  '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
                  mt: 1,
                }}
                component="form"
                noValidate
                onSubmit={handleSubmit}>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`name`}
                    label="Name *"
                    placeholder="Enter Name"
                    startAdornment={
                      <InputAdornment
                        position="start"
                        sx={{
                          pr: '0 !important',
                          mx: '0 !important',
                          borderRight: '0 !important',
                        }}>
                        <MFSelectField
                          name={`namePrefix`}
                          items={salutationsMasters.map((salutation) => ({
                            key: salutation,
                            value: salutation,
                          }))}
                          sx={{
                            color: 'primary.main',
                            '.MuiSvgIcon-root ': { color: 'primary.main' },
                            '&.MuiInputBase-root': {
                              '.MuiSelect-select': {
                                p: 0,
                                pr: 2.5,
                                border: 0,
                              },
                            },
                            '&,&:hover,&.Mui-focused': {
                              '.MuiOutlinedInput-notchedOutline': { border: 0 },
                            },
                          }}
                        />
                      </InputAdornment>
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`pan`}
                    label="PAN *"
                    placeholder="Enter Pan"
                    inputProps={{ style: { textTransform: 'uppercase' } }}
                    onChange={(e) => {
                      setFieldValue('pan', e.target.value.toUpperCase());
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`mobile`}
                    label={`Mobile Number *`}
                    placeholder="Enter Mobile Number"
                    onKeyDown={(e) => {
                      preventSpecialCharacters(e);
                    }}
                    startAdornment={
                      <CountryCodesDropDown
                        ElementWidth={mobileElementWidth && mobileElementWidth}
                        name={`countryNameAndCode`}
                        value={values.countryNameAndCode}
                      />
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`email`}
                    label="Email ID (Office ID Only) *"
                    placeholder="Enter Email ID"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`designation`}
                    label="Designation *"
                    placeholder="Enter Designation"
                  />
                </Grid>
                <Grid item xs={12} sm={6} mt={3}>
                  <DatePicker
                    label={'Date of birth *'}
                    inputLabelStyles={{
                      transform: 'unset',
                      fontSize: 14,
                      fontWeight: 500,
                      color: 'rgba(0,0,0,0.7)',
                      mt: -3,
                    }}
                    placeholder={'Enter Date of birth'}
                    name={`dateOfBirth`}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFSelectField
                    name={`gender`}
                    label="Gender *"
                    items={genderMasters.map((gender) => ({ key: gender, value: gender }))}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <SearchableSelect
                    name={`nationality`}
                    label="Nationality *"
                    items={nationalitiesMdmsResponse.map((nationality) => ({
                      key: nationality.name,
                      value: nationality.name,
                    }))}
                    searchFieldPlaceholder={'Search Nationality'}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`aadhaar`}
                    label="Aadhaar last 4 digit *"
                    placeholder="Enter Aadhaar last 4 digit"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`ckycNo`}
                    label="CKYC Number"
                    placeholder="Enter CKYC Number"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`fatherName`}
                    label="Father / Spouse Name *"
                    placeholder="Enter Father / Spouse Name"
                    startAdornment={
                      <InputAdornment
                        position="start"
                        sx={{
                          pr: '0 !important',
                          mx: '0 !important',
                          borderRight: '0 !important',
                        }}>
                        <MFSelectField
                          name={`fatherOrSpouseNamePrefix`}
                          items={salutationsMasters.map((salutation) => ({
                            key: salutation,
                            value: salutation,
                          }))}
                          sx={{
                            color: 'primary.main',
                            '.MuiSvgIcon-root ': { color: 'primary.main' },
                            '&.MuiInputBase-root': {
                              '.MuiSelect-select': {
                                p: 0,
                                pr: 2.5,
                                border: 0,
                              },
                            },
                            '&,&:hover,&.Mui-focused': {
                              '.MuiOutlinedInput-notchedOutline': { border: 0 },
                            },
                          }}
                        />
                      </InputAdornment>
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`motherName`}
                    label="Mother Name"
                    placeholder="Enter Mother Name"
                    startAdornment={
                      <InputAdornment
                        position="start"
                        sx={{
                          pr: '0 !important',
                          mx: '0 !important',
                          borderRight: '0 !important',
                        }}>
                        <MFSelectField
                          name={`motherNamePrefix`}
                          items={salutationsMasters.map((salutation) => ({
                            key: salutation,
                            value: salutation,
                          }))}
                          sx={{
                            color: 'primary.main',
                            '.MuiSvgIcon-root ': { color: 'primary.main' },
                            '&.MuiInputBase-root': {
                              '.MuiSelect-select': {
                                p: 0,
                                pr: 2.5,
                                border: 0,
                              },
                            },
                            '&,&:hover,&.Mui-focused': {
                              '.MuiOutlinedInput-notchedOutline': { border: 0 },
                            },
                          }}
                        />
                      </InputAdornment>
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFSelectField
                    name={`pepStatus`}
                    label={`Politically Exposed Person (PEP)*`}
                    items={PEPsMasters.map((pep) => ({ key: pep, value: pep }))}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFSelectField
                    name={`relatedPersonType`}
                    label={`Related Person Type *`}
                    items={Object.keys(relatedPersonTypeMaster).map((Id) => ({
                      key: relatedPersonTypeMaster[Id],
                      value: Id,
                    }))}
                  />
                </Grid>
                {checkforOtherRelatedPerson(values.relatedPersonType) && (
                  <Grid item xs={12} sm={6}>
                    <MFTextField
                      name={`otherRelatedPersonType`}
                      label={`Other Related Person Type *`}
                      placeholder="Enter Other Related Person Type"
                    />
                  </Grid>
                )}
                {isRelatedPersonTypeDirector(values.relatedPersonType) && (
                  <Grid item xs={12} sm={6}>
                    <MFTextField name={`din_uid`} label="DIN" placeholder="Enter DIN" />
                  </Grid>
                )}
                {!isRelatedPersonTypeDirector(values.relatedPersonType) && (
                  <Grid item xs={12} sm={6}>
                    <MFTextField name={`uid`} label="UID" placeholder="Enter UID" />
                  </Grid>
                )}
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`address1`}
                    label="Address Line 1 *"
                    placeholder="Enter Address Line 1"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`address2`}
                    label="Address Line 2 *"
                    placeholder="Enter Address Line 2"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`address3`}
                    label="Address Line 3 *"
                    placeholder="Enter Address Line 3"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField name={`city`} label="City *" placeholder="Enter City" />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField name={`state`} label="State *" placeholder="Enter State" />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField name={`pincode`} label="Pincode *" placeholder="Enter Pincode" />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <SearchableSelect
                    name={`country`}
                    label="Country *"
                    items={nationalitiesMdmsResponse.map((nationality) => ({
                      key: nationality.name,
                      value: nationality.name,
                    }))}
                    searchFieldPlaceholder={'Search Country'}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Grid
                    container
                    sx={{
                      width: '100%',
                      ml: 0,
                      // '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
                      mt: 2,
                    }}>
                    {groupSignatoriesDocData.map((groupSignatoryData, index) => {
                      return (
                        <React.Fragment key={index}>
                          <Grid
                            item
                            sx={{
                              mt: 4,
                              paddingLeft: '0px!important',
                            }}
                            xs={12}
                            sm={6}>
                            {groupSignatoryData.options ? (
                              <MFSelectField
                                name={`groupsignatorydocuments.${index}.documentName`}
                                label={`${groupSignatoryData.documentName} ${
                                  groupSignatoryData.required === 'true' ? '*' : ''
                                }`}
                                // label={getLabel(
                                //   groupSignatoryData.documentName,
                                //   groupSignatoryData.documentType,
                                //   groupSignatoryData.required,
                                //   values,
                                //   index
                                // )}
                                items={groupSignatoryData.options.map((item: string) => ({
                                  key: item,
                                  value: item,
                                }))}
                                // disabled={isFieldDisabled}
                                applyLabelStyles={true}
                              />
                            ) : (
                              <Typography
                                style={{
                                  color: 'rgba(0, 0, 0, 0.7)',
                                  fontWeight: 500,
                                  textAlign: 'left',
                                  fontSize: 14,
                                  marginBottom: 10,
                                  marginTop: 6,
                                }}>
                                {groupSignatoryData.documentName}
                                {groupSignatoryData.required === 'true' && (
                                  <span style={{ color: 'red' }}>*</span>
                                )}
                              </Typography>
                            )}
                          </Grid>
                          <Grid
                            item
                            sx={{
                              mt: 5,
                              paddingRight: '0px!important',
                            }}
                            xs={12}
                            sm={6}>
                            <FileUpload
                              onFileChange={(value, documentId, removeFile, result) => {
                                const { file, ...rest } = values.groupsignatorydocuments[index];
                                setFieldValue(`groupsignatorydocuments.${index}`, {
                                  ...rest,
                                  documentId,
                                  fileView: result,
                                  ...(!removeFile && { file: result?.id ? result : file }),
                                });
                              }}
                              documentData={{
                                ...values.groupsignatorydocuments[index],
                                documentDetails: '',
                                documentId: '',
                                isActive: true,
                              }}
                              name={`groupsignatorydocuments.${index}.documentId`}
                              errorTextAlign="flex-start"
                              fileValidateType={{
                                'image/jpeg': '.jpeg',
                                'image/jpg': '.jpg',
                                'image/png': '.png',
                              }}
                              supportTitle="jpeg, png, jpg"
                            />
                          </Grid>
                          {documentTypeValidationCheckForDocumentNumberDocumentExpiryDate(
                            groupSignatoryData.documentType
                          ) && (
                            <ProofDetails
                              index={index}
                              doc={values.groupsignatorydocuments[index]}
                            />
                          )}
                        </React.Fragment>
                      );
                    })}
                  </Grid>
                </Grid>
                <Grid xs={12} sm={12} lg={12} display="flex" sx={{ justifyContent: 'center' }}>
                  <Button
                    variant="contained"
                    sx={{
                      fontSize: 15,
                      minWidth: 180,
                      letterSpacing: 2,
                      fontWeight: 500,
                      alignSelf: 'center',
                      mt: 2,
                    }}
                    type="submit">
                    {authorisedSignatories.pan ? 'Save' : 'Add'}
                  </Button>
                </Grid>
              </Grid>
            )}
          </Formik>
        </Box>
      </Dialog>
      <ConfirmationDialog
        message={'Are you sure you want to delete Member ?'}
        open={deletePopup}
        setOpen={() => setDeletePopup(false)}
        onSave={() => {
          setDeletePopup(false);
          const deleteSignatory = authorisedSignatoriesGroup.map((group, ind) => {
            if (ind === groupIndex) {
              return {
                ...group,
                name: getGroupNameMaster[groupIndex],
                threshold: group.threshold,
                groupsignatories: group.groupsignatories
                  .filter((_item) => _item.isActive)
                  .map((signatory, _ind) => {
                    if (rowIndex === _ind) {
                      return { ...signatory, isActive: false };
                    }
                    return signatory;
                  }),
              };
            }
            return group;
          });

          // const deletedSignatory = authorisedSignatoriesGroup.map((group, _ind) => {
          //   if (_ind === groupIndex) {
          //     return {
          //       ...group,
          //       name: getGroupNameMaster[groupIndex],
          //       threshold: group.threshold,
          //       groupsignatories: group.groupsignatories.filter(
          //         (_signatory) => !_signatory.isActive && _signatory.id
          //       ),
          //     };
          //   }
          //   return group;
          // });
          const active_DeletedSignatory = deleteSignatory.map((group, _ind) => {
            if (_ind === groupIndex) {
              return {
                ...group,
                name: getGroupNameMaster[groupIndex],
                threshold: group.threshold,
                groupsignatories: [
                  ...authorisedSignatoriesGroup[groupIndex].groupsignatories.filter(
                    (_signatory) => !_signatory.isActive && _signatory.id
                  ),
                  ...group.groupsignatories.filter(
                    (_signatory) => _signatory.isActive || (!_signatory.isActive && _signatory.id)
                  ),
                ],
              };
            }
            return group;
          });
          //const setAuthorisedSignatories=deleteSignatory[groupIndex].groupsignatories:[...active_DeletedSignatory[groupIndex].groupsignatories,...deleteSignatory[groupIndex].groupsignatories]
          setAuthorisedSignatoriesGroup(active_DeletedSignatory);
          setAuthorisedSignatories({
            ...GroupSignatoriesObject,
            groupsignatorydocuments: groupSignatoriesDocData,
          }),
            setRowIndex(Number),
            setGroupIndex(Number);
          // try {
          //   const deleteSignatory = authorisedSignatoriesGroup.map((group, ind) => {
          //     if (ind === groupIndex) {
          //       return {
          //         ...group,
          //         name: getGroupNameMaster[groupIndex],
          //         threshold: group.threshold,
          //         groupsignatories: group.groupsignatories.map((signatory, _ind) => {
          //           if (rowIndex === _ind) {
          //             return { ...signatory, isActive: false };
          //           }
          //           return signatory;
          //         }),
          //       };
          //     }
          //     return group;
          //   });
          //   authorisedSignatoriesGroup.map((group) => {
          //     const getCanEsignCount = group.groupsignatories.filter((item) => item.canEsign);
          //     if (getCanEsignCount.length < group.threshold) {
          //       throw 'Authorised Signatories that can esign cannot be less than the threshold';
          //     }
          //     return group;
          //   });
          //   const { id } = application || {};
          //   if (id && authorisedSignatories.groupId) {
          //     await dispatch(
          //       updateApplication({
          //         body: {
          //           ...application,
          //           groups: deleteSignatory,
          //         },
          //         applicationId: id,
          //       })
          //     );
          //     return;
          //   }
          //   const deletedSignatories = deleteSignatory.map((group, _ind) => {
          //     if (_ind === groupIndex) {
          //       return {
          //         ...group,
          //         name: getGroupNameMaster[groupIndex],
          //         threshold: group.threshold,
          //         groupsignatories: group.groupsignatories.filter(
          //           (_signatory) => _signatory.isActive
          //         ),
          //       };
          //     }
          //     return group;
          //   });
          //   setAuthorisedSignatoriesGroup(deletedSignatories);
          //   setAuthorisedSignatories(GroupSignatoriesObject),
          //     setRowIndex(Number),
          //     setGroupIndex(Number);
          // } catch (e) {
          //   //typeof e === 'string' && dispatch(showError(e));
          //   console.error((e as Error).message);
          // }
        }}
        onCancel={() => {
          setAuthorisedSignatories({
            ...GroupSignatoriesObject,
            groupsignatorydocuments: groupSignatoriesDocData,
          }),
            setRowIndex(Number),
            setGroupIndex(Number),
            setDeletePopup(false);
        }}
      />
    </Grid>
  );
}
